import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const AccountsIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg} focusable="false">
      <path d="M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 55-10 114t-32 117-53 108-74 89-97 61-118 23q-54 0-105-14t-96-42-80-66-61-88q-30 47-69 85t-85 67-98 43-110 15q-102 0-185-44t-141-117-90-164-32-187q0-95 31-187t90-164 142-116 185-45q95 0 176 41t144 112V512h128v640q0 53 20 99t55 82 81 55 100 20q44 0 80-18t65-49 50-70 34-83 20-85 7-79q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32q178 0 343-68l49 118q-94 39-192 58t-200 20q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm-64 1408q75 0 134-34t101-90 63-123 22-137q0-68-22-136t-63-124-100-89-135-35q-75 0-134 34t-101 90-63 123-22 137q0 68 22 136t63 124 100 89 135 35z" />
    </svg>
  ),
  displayName: 'AccountsIcon',
});

export default AccountsIcon;
